var React = require('react');

function Template (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"#333","strokeLinecap":"round","strokeLinejoin":"round"},[React.createElement("rect",{"width":"6","height":"6","x":"4","y":"4","rx":"1","key":0}),React.createElement("rect",{"width":"6","height":"6","x":"14","y":"4","rx":"1","key":1}),React.createElement("rect",{"width":"6","height":"6","x":"4","y":"14","rx":"1","key":2}),React.createElement("rect",{"width":"6","height":"6","x":"14","y":"14","rx":"1","key":3})]));
}

Template.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Template;

Template.default = Template;
